var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["modal/modal-contents.j2"] = require( "modal/modal-contents.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/user/ugc-photo-upload/photo-upload.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("modal/modal-contents.j2", true, "core/templates/modal/user/ugc-photo-upload/photo-upload.j2", false, function(t_2,_parentTemplate) {
if(t_2) { cb(t_2); return; }
parentTemplate = _parentTemplate
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\n";
var t_3;
t_3 = true;
frame.set("overlayHidden", t_3, true);
if(frame.topLevel) {
context.setVariable("overlayHidden", t_3);
}
if(frame.topLevel) {
context.addExport("overlayHidden", t_3);
}
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modal_styles"))(env, context, frame, runtime, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
output += t_4;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modal_contents"))(env, context, frame, runtime, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
output += t_6;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modal_styles(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\n    o-modal--ugc-upload-modal\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modal_contents(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\n\n    <iframe\n        id=\"curalate-photo-picker\"\n        class=\"c-ugc-upload\"\n        src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "ugcIframeSrc"), env.opts.autoescape);
output += "\"\n        scrolling=\"no\"\n        frameborder=\"0\"\n        data-qa-ugc-photo-upload>\n        </iframe>\n\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_modal_styles: b_modal_styles,
b_modal_contents: b_modal_contents,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/user/ugc-photo-upload/photo-upload.j2"] , dependencies)